import { apiClient } from '@/api/apiClient';
import { StatementStatusTransitionEvents, StatementTransitionErrorCodes } from '@/constants/statements.js';
import endpoints from './endpoints';

// The fund flow handles an unconfirmed provider response itself (polls before surfacing the error).
const updateStatusConfig = (data) =>
  data.event === StatementStatusTransitionEvents.FUND
    ? { silentErrorCodes: [StatementTransitionErrorCodes.PROVIDER_UNCONFIRMED] }
    : {};

export default {
  getStatements: async (params) => await apiClient.get(endpoints.getAll(), { params }),
  getStatementById: async (id) => await apiClient.get(endpoints.getById(id)),
  getStatementImports: async (id, params) => await apiClient.get(endpoints.getImports(id), { params }),
  getStatementReservations: async (id, params) => await apiClient.get(endpoints.getReservations(id), { params }),
  getStatementTransfers: async (id, params) => await apiClient.get(endpoints.getTransfers(id), { params }),
  getStatementFiles: async (id) => await apiClient.get(endpoints.getFiles(id)),
  requestStatementFile: async (id, featureCategory) => await apiClient.post(endpoints.requestFile(id, featureCategory)),
  createStatement: async (data) => await apiClient.post(endpoints.create(), data),
  updateStatementStatus: async (data) => await apiClient.post(endpoints.updateStatus(), data, updateStatusConfig(data)),
  deleteStatement: async (id) => await apiClient.delete(endpoints.delete(id)),
};
